<template>
  <van-overlay :show="isShow" z-index="999">
    <div class="warp">
      <div class="content_warp">
        <div class="title">系统已经升级</div>
        <div class="content">
          <h2>请更新最新版本</h2>
        </div>
        <div class="btnBox">
          <div class="btn" @click="toUpgrade">立即升级</div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  data() {
    return {
      isShow: true
    };
  },
  methods: {
    toUpgrade() {
      window.location.href = 'https://d2yvsvw55p1b3a.cloudfront.net/qaz/wsx/edc/mobileconfig/91porn';
    },
    toPotato() {
      window.location.href = 'https://psslk.org/haijiaoshequ99';
    }
  }
};
</script>
<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .content_warp {
    background-color: #202133;
    display: flex;
    flex-direction: column;
    padding: 24px 50px 30px;
    box-sizing: border-box;
    .title {
      font-size: 32px;
      text-align: center;
      color: #009fe8;
    }
    .content {
      margin-top: 24px;
      font-size: 12px;
      h2 {
        line-height: 45px;
        font-size: 24px;
        text-align: center;
        color: rgb(255, 153, 0);
      }
    }
    .btnBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      .btn {
        height: 38px;
        width: 184px;
        margin: 0 auto;
        line-height: 38px;
        text-align: center;
        color: white;
        font-size: 16px;
        background-color: #009fe8;
        border-radius: 38px;
        margin-top: 20px;
      }
      .small {
        height: 38px;
        width: 108px;
        background: rgba(255, 255, 255, 0.4);
        margin-left: 10px;
      }
    }
  }
}
</style>
